import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { config } from '../../shared/config';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { StorageService } from '../../core/storage/storage.service';
import { BaseHttpService } from '../../core/services/base-http.service';
import { UnitAllData } from '../../units/models/unit-all-data';
import { TripTypeEnum } from '../../shared/models/trip-type.enum';
import { StartRoute } from '../../shared/models/startRoute';
import { RouteDetails } from '../../shared/models/route-details';

@Injectable({
  providedIn: 'root'
})
export class TracksService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }
  

  getRoutes(unitIds: number[], from: string, to: string): Observable<RouteDetails[]> {

    let dateFrom = from;
    let dateTo = to || moment().utc().subtract(1, 's').format();
    if (moment().isBefore(moment(to))) {
      dateTo = moment().utc().subtract(1, 's').format();
    }
    if (moment(dateTo).isBefore(moment(dateFrom))) {
      dateFrom = moment(dateTo).startOf('d').utc().format();
    }
    const params: string = `?unitIds=${unitIds.join()}&From=${dateFrom}&To=${dateTo}`
    const url = config.generateApiUrl(`Routes${params}`, ['*'], null, '2.2');
    return this.get(url)
      .pipe(
        map((request) => {
          const routes = request['data']['items'] as RouteDetails[];
          let stopId = 1;
          let routeId = 1;
          routes.map((route) => {
            route.routeType = route.isDrive ? 'drive' : 'stop';
            route.routeId = route.isDrive ? routeId : stopId;
            route.routeEnd = route.routeStop;
            route.distanceMeters = route.totalDistanceMeterStop - route.totalDistanceMeterStart;
            route.averageSpeedKmph = route.averageSpeedMeterPerSecond * 3.6;
            if (route.routeType === 'stop') { stopId++; }
            if (route.routeType === 'drive') { routeId++; }
          });
          return routes;
        })
      );
  }

  startRoute(unit: UnitAllData, tripType: TripTypeEnum): Observable<StartRoute> {
    const url = config.generateApiUrl(`Driver/route`, ['*'], null, '2.2');
    const body: StartRoute = {
      unitId: unit?.unit?.unitId,
      privateRoute: tripType === TripTypeEnum.PRIVATE,
      dateFrom: moment().utc().format()
    };
    return this._http.post(url, body).pipe(
        map(request =>  request['data'] as StartRoute)
      );
  }

  getDriving(): Observable<StartRoute> {
    const url = config.generateApiUrl(`Driver/route`, ['*'], null, '2.2');
    return this.get(url).pipe(
      map(request =>  request['data'] as StartRoute)
    );
  }


  stopRoute(unitId: number): Observable<Partial<StartRoute>> {
    const url = config.generateApiUrl(`Driver/route`, ['*'], null, '2.2');
    const body: Partial<StartRoute> = {
      unitId: unitId,
      dateTo: moment().utc().format()
    }
    return this._http.put(url, body).pipe(
      map(request =>  request['data'] as Partial<StartRoute>)
    );
  }
}
